/**
 * @author vishwadeep.kapoor
 * @see /client/containers/MyEGiftCards/index.js
 */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { utils } from '../../devUtils';
const StyledDetails = styled.div`
  font-size:13px;
  ul{
    list-style:none;
    padding:0px;
    margin:0px;
    li{
      display:block;
      margin-bottom:5px;
      white-space:normal;
      b{
        font-weight:600;
        color:${(props) => props.theme.mediumGrey};
        margin-right:5px;
      }
    }
  }
`;

function Details(props) {
  const { data: { value: { order_no, created_at } = {}, original: { shipping_address: { email } } = {} } = {} } = props;
  return (
    <StyledDetails>
      <ul>
        <li><b>Order Number :</b>{order_no}</li>
        <li><b>Order Date :</b>{utils.formattedDate(created_at)}</li>
        <li><b>Delivered to :</b>&nbsp;{email}</li>
      </ul>
    </StyledDetails>
  );
}

Details.propTypes = {
  data: PropTypes.object,
};
export default Details;



// WEBPACK FOOTER //
// client/containers/MyEGiftCards/details.js